import { reactive, ref, computed } from '@vue/composition-api'
import * as common from '@/util/common'
import { faComputerSpeaker } from '@fortawesome/pro-light-svg-icons'

/**
 * 書籍一覧画面：パッケージ＆商品一覧表示エリアツリー表示
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    // ヒット件数表示フラグ
    isSearchCountShown: computed(() => {
      return props.isSearchCountShown
    }),

    // 詳細検索実行中フラグ
    isSearchDetail: computed(() => {
      return props.isSearchDetail
    }),

    // 検索結果件数(画面表示用)
    search_count_disp: computed(() => {
      return common.breakComma(props.model.search_count)
    }),

    /**
     * 初期表示処理
     */
    init: () => {
    },
    // チェックボックスのチェック状態
    isChecked: computed({
      get: () => {
        return props.model.isChecked
      },
      set: (isChecked) => {
        props.model.isChecked = isChecked
      }
    }),
    isParent: computed(() => {
      return true
    }),
    isOpen: true,
    isFolder: computed(() => {
      const packagesExist = (typeof props.model.packages !== 'undefined') && Array.isArray(props.model.packages) && (props.model.packages.length > 0) 
      const productsExist = (typeof props.model.products !== 'undefined') && Array.isArray(props.model.products) && (props.model.products.length > 0)
      const booksExist = (typeof props.model.books !== 'undefined') && Array.isArray(props.model.books) && (props.model.books.length > 0)
      return (packagesExist || productsExist || booksExist)
    }),
    children: computed(() => {
      return (props.model.packages || props.model.products || props.model.books)
    }),
    toggle: () => {
      if (group1.isFolder) {
        group1.isOpen = !group1.isOpen
      }
    },
    itemType: computed(() => {
      return props.model.itemType
    }),

    /**
     * 項目をクリックした場合
     * @see https://pdwslmr.netlify.app/posts/web/vue-composition-api-howto/
     */
    itemClicked: (model) => {

      const targetNodeId = model.id
      const targetIdsMap = {}
      if (group1.itemType === 'package') {
        targetIdsMap.package_id = model.package_id
      } else if (group1.itemType === 'product') {
        targetIdsMap.product_id = model.product_id
      } else if (group1.itemType === 'book') {
        targetIdsMap.product_id = model.product_id
        targetIdsMap.book_id = model.book_id
      }

      if (Object.keys(targetIdsMap).length > 0) {
        // ルートのノードにitemClicked()の実行を伝える
        group1.emitItemClicked({nodeId: targetNodeId, targetIdsMap: targetIdsMap})
      }
    },

    /**
     * ルートのノードにitemClicked()の実行を伝える
     */
    emitItemClicked: ({nodeId, itemType, id}) => {
      context.emit('emitItemClicked', {nodeId: nodeId, itemType: itemType, id: id})
    }
  })

  return group1
}
